/* P2-3 L — Three-step scroll-pinned demo.
 *
 * Desktop only (≥ 990px) and only when the user has not requested
 * reduced motion. We mark the section [data-nb-three-step-pinned]
 * which the CSS uses to enable the 280vh-tall track + sticky stage.
 * As the user scrolls through the track, we map progress (0–1) to
 * the active step (1, 2, or 3) and write it back to the section
 * via [data-active-step]. CSS handles the rest (image pan, list
 * highlight, floating step tag).
 *
 * Mobile and reduced-motion users get the original side-by-side
 * layout with no pinning. */
(function () {
  'use strict';

  function init(section) {
    const track = section.querySelector('[data-nb-three-step-track]');
    if (!track) return;

    const stepCount = section.querySelectorAll('.nb-three-step__item').length || 3;
    const mqDesktop = window.matchMedia('(min-width: 990px)');
    const mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    let rafId = 0;
    let lastStep = 1;

    function update() {
      rafId = 0;
      const rect = track.getBoundingClientRect();
      const vh = window.innerHeight || 1;
      // progress = how far the track has been scrolled into the
      // viewport, normalised 0–1 over the scrollable distance
      // (track height minus one viewport).
      const total = rect.height - vh;
      if (total <= 0) return;
      const scrolled = Math.min(Math.max(-rect.top, 0), total);
      const progress = scrolled / total;
      // Bucket into stepCount slots. Bias slightly so the first
      // step is held longer at the top (gives the user a beat to
      // read before the image begins panning).
      const idx = Math.min(stepCount - 1, Math.floor(progress * stepCount));
      const step = idx + 1;
      if (step !== lastStep) {
        section.setAttribute('data-active-step', String(step));
        lastStep = step;
      }
    }

    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(update);
    }

    function applyPin() {
      const enable = mqDesktop.matches && !mqReduced.matches;
      section.setAttribute('data-nb-three-step-pinned', enable ? 'true' : 'false');
      if (enable) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      } else {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        section.setAttribute('data-active-step', '1');
        lastStep = 1;
      }
    }

    applyPin();
    mqDesktop.addEventListener('change', applyPin);
    mqReduced.addEventListener('change', applyPin);
  }

  function boot() {
    document.querySelectorAll('[data-nb-three-step]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
